const tours = {
  tour: "Wisata", // translated 
  tours: "Tur", // translated 
  addOn: "Tambahan", // translated 
  addOns: "Tambahkan", // translated 
  availableEscapes: "Escape yang Tersedia", // translated 
  availableExperiences: "Pengalaman yang Tersedia", // translated 
  getRequest: "Dapatkan Permintaan", // translated 
  sendRequest: "Kirim Permintaan", // translated 
};



export default tours;
